export default {
  // apiUrl: 'https://api.keepreading.webtestdev.site',
  apiUrl: process.env.REACT_APP_SERVER_URL || 'https://lycanfitness.com/',
};